import Vue from 'vue'
import cart from '@/js/lib/cart'
import state from '@/js/lib/appState'
import { formatMoney } from '@/js/lib/util'
import select from 'select-dom'
import { datalayerAddToCardSubscription } from '@/js/lib/datalayer'

const Cart = new Vue({
  data () {
    return {
      state
    }
  },
  methods: {
    observeRebuyProductGrid() {
      const rebuyProductGrid = document.querySelector('.js-rebuy-donation .rebuy-widget-container.is-visible .rebuy-product-grid')
      if (!rebuyProductGrid) return
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'childList') {
            this.rebuyUpdateWidgetMarkup()
          }
        })
      })
      observer.observe(rebuyProductGrid, {
        childList: true,
        subtree: false
      })
    },
    rebuyUpdateWidgetMarkup() {
      document.querySelectorAll('.js-rebuy-donation .rebuy-widget-container.is-visible .rebuy-product-block').forEach(productBlock => {
        const productMedia = productBlock.querySelector('.rebuy-product-media')
        const productInfo = productBlock.querySelector('.rebuy-product-info')
        const productActions = productBlock.querySelector('.rebuy-product-actions')
        const productTitleLink = productBlock.querySelector('.rebuy-product-title')
        const productWrapper = productBlock.querySelector('.rebuy-product-wrapper')

        if (!productMedia || !productInfo || !productActions || !productTitleLink || productWrapper) return

        const href = productTitleLink.getAttribute('href')
        const ariaLabel = productTitleLink.getAttribute('aria-label')
        const ariaLevel = productTitleLink.getAttribute('aria-level')
        const rel = productTitleLink.getAttribute('rel')

        const productImageLink = productMedia.querySelector('.rebuy-product-image')
        const newProductImage = document.createElement('div')
        newProductImage.className = 'rebuy-product-image'
        newProductImage.innerHTML = productImageLink.innerHTML
        productMedia.replaceChild(newProductImage, productImageLink)

        const productTitleText = productTitleLink.textContent
        const newProductTitle = document.createElement('p')
        newProductTitle.className = 'rebuy-product-title'
        newProductTitle.textContent = productTitleText
        productInfo.replaceChild(newProductTitle, productTitleLink)

        const wrapperLink = document.createElement('a')
        wrapperLink.setAttribute('href', href)
        wrapperLink.setAttribute('aria-label', ariaLabel)
        wrapperLink.setAttribute('aria-level', ariaLevel)
        wrapperLink.setAttribute('rel', rel)
        wrapperLink.className = 'rebuy-product-wrapper'

        wrapperLink.appendChild(productMedia)
        wrapperLink.appendChild(productInfo)

        productBlock.insertBefore(wrapperLink, productActions)
      })
    },
    RebuyRestructure () {
      const rebuyEl = select.all('.js-rebuy-mini-cart')
      if (rebuyEl) {
        rebuyEl.forEach(item => {
          const rebuyTitleEl = select('.rebuy-product-title', item)
          const widgettypecartEl = select('.rebuy-product-grid', item)
          if (rebuyTitleEl) {
            rebuyTitleEl.setAttribute('role', 'heading')
            rebuyTitleEl.setAttribute('aria-level', '3')
          }
          if (widgettypecartEl) {
            widgettypecartEl.setAttribute('role', 'group')
            widgettypecartEl.setAttribute('aria-level', 'product')
          }
        })
      }
      const rebuyProductThumbLink = select('.rebuy-product-image')
      if (rebuyProductThumbLink) {
        rebuyProductThumbLink.removeAttribute('tabindex')
      }

      document.addEventListener('rebuy.ready', () => {
        this.rebuyUpdateWidgetMarkup()
        this.observeRebuyProductGrid()
      })
    },
    RebuyDestroy () {
      this.rebuyNode = document.getElementById('rebuy-render')
      this.RebuyNode?.childNodes?.forEach(item => item.remove())
    },
    RebuyInit () {
      this.rebuyNode = document.getElementById('rebuy-render')
      if (this.rebuyNode === null) return;
      console.log('BRL:RebuyInit')

      let rebuy = '<div class="rebuy--mini-cart js-rebuy-mini-cart" data-rebuy-id="81625"></div>'
      rebuy += '<div class="rebuy--mini-cart js-rebuy-mini-cart" data-rebuy-id="31301"></div>'
      rebuy += '<div class="rebuy--donation js-rebuy-donation" data-rebuy-id="56641"></div>'

      this.rebuyNode.innerHTML = rebuy
      this.rebuyCheck = setInterval(() => {
        if (window.Rebuy !== undefined) {
          window.Rebuy.init()
          clearInterval(this.rebuyCheck)
          this.RebuyRestructure()
        }
      }, 500)
    },
    getCart () {
      return cart.get().then((data) => {
        state.cart = data
        this.addKlaviyoEvent(data)
      })
    },
    openMiniCart () {
      this.getCart()
      this.state.isMiniCartOpen = true
    },
    addKlaviyoEvent (data) {
      const isProductBYB = window.location.href.includes('tools/bundle-subscriptions/bundle')
      window._learnq = window._learnq || []
      if (data && data.items) {
        data.items.map(product => {
          const item = {
            Name: product.title.replace('&amp;', '&'),
            ProductID: product.id,
            Categories: product.categories,
            ImageURL: product.image,
            URL: isProductBYB ? window.location.href : window.location.origin + product.url,
            Brand: product.vendor,
            Price: formatMoney(product.price),
            CompareAtPrice: formatMoney(product.compareAtPrice)
          }
          _learnq.push(['track', 'Added to Cart', item])
        })
      }
    },
    datalayerAddToCard(cartItems) {
      cart.get().then((cartData) => {
        const tempArr = cartData.items.filter(item =>
          cartItems.some(cartItem =>
            parseInt(cartItem.id) === parseInt(item.id)
            && cartItem.quantity === item.quantity
            && (cartItem.properties?._bundleUid && item.properties?._bundleUid ? cartItem.properties._bundleUid === item.properties._bundleUid : true)
          )
        )
        datalayerAddToCardSubscription([...new Set(tempArr)])
      })
    }
  }
})
window.BARREL.CartUtils = cart
window.BARREL.GetCart = Cart.getCart
window.BARREL.OpenMiniCart = Cart.openMiniCart
window.BARREL.RebuyInit = Cart.RebuyInit
window.BARREL.RebuyDestroy = Cart.RebuyDestroy
window.BARREL.DatalayerAddToCard = Cart.datalayerAddToCard
